// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const Profile = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M48 54.865c-6.88 0-12.477-5.597-12.477-12.477 0-6.879 5.597-12.477 12.477-12.477s12.477 5.598 12.477 12.477c0 6.88-5.597 12.477-12.477 12.477m23.305 19.88c-1.332-8.374-7.085-15.29-14.784-18.28 4.759-2.894 7.956-8.113 7.956-14.077 0-9.085-7.392-16.477-16.477-16.477s-16.477 7.392-16.477 16.477c0 5.965 3.196 11.183 7.956 14.076-7.699 2.992-13.452 9.907-14.784 18.281C17.23 68.232 12.5 58.661 12.5 48c0-19.575 15.925-35.5 35.5-35.5S83.5 28.425 83.5 48c0 10.661-4.73 20.232-12.195 26.745m-42.862 2.862C28.897 67.2 37.482 58.865 48 58.865c10.518 0 19.103 8.334 19.557 18.742A35.282 35.282 0 0 1 48 83.5a35.282 35.282 0 0 1-19.557-5.893M48 8.5C26.22 8.5 8.5 26.22 8.5 48S26.22 87.5 48 87.5 87.5 69.78 87.5 48 69.78 8.5 48 8.5"
			fillRule="evenodd"
		/>
	</svg>
);
export default Profile;
